import { Component, OnInit, Input, Output, EventEmitter, } from '@angular/core';
import { FormBuilder, FormGroup, Validators, FormControl, FormArray, } from '@angular/forms';
import { DataserviceService } from 'src/app/dataservice.service';
import { NzMessageService } from 'ng-zorro-antd/message';

@Component({
  selector: 'app-dish-plans',
  templateUrl: './dish-plans.component.html',
  styleUrl: './dish-plans.component.css'
})
export class DishPlansComponent {
  @Input() fullData: any;
  @Output() plans = new EventEmitter<any>();

  planForm: FormGroup;

  dishPlans: any;
  dishPlanOffers: any;
  channels: any;
  promos: any;
  loadingId: any;
  loadingPlans: boolean = false;
  submittingLoader: boolean = false;

  constructor(
    private fb: FormBuilder,
    private data: DataserviceService,
    private message: NzMessageService
  ) {
    this.planForm = this.fb.group({
      dishPlan: ['', Validators.required],
      dishPlanOffer: ['', Validators.required],
      addOnChannels: this.fb.array([]),
      offers: this.fb.array([]),
    });

    this.planForm.get('dishPlan')?.valueChanges.subscribe(val => {
      this.getPlanOffers();
    });
  }

  ngOnInit() {
    console.log(this.fullData)
    this.loadingPlans = true;
    this.loadingId = this.message.loading('Getting Plans...', { nzDuration: 0 }).messageId;

    this.data.postDataNoBodyDotBody({
      promoName: this.fullData.qual.promoName || null,
      conversationId: this.fullData.conversationId,
      promoId: this.fullData.qual.promoId || null,
    },'dish/getChannels').subscribe(
      (r: any) => {
        this.channels = r.data.channels.sort((a: any, b: any) => 
          a.category.localeCompare(b.category)
        );
        this.promos = this.groupPromos(r.data.promos);
        this.dishPlans = r.data.plans;

        if(this.fullData?.plans) {
          const fa = this.planForm.get('addOnChannels') as FormArray;
          const fa2 = this.planForm.get('offers') as FormArray;

          this.planForm.patchValue({
            dishPlan: this.fullData?.plans.obj.dishPlan,
            dishPlanOffer: this.fullData?.plans.obj.dishPlanOffer,
            addOnChannels: this.fullData?.plans.obj.addOnChannels?.forEach((p: any) => fa.push(new FormControl(p))),
            offers: this.fullData?.plans.obj.offers?.forEach((p: any) => fa2.push(new FormControl(p)))
          });
          this.planForm.updateValueAndValidity();

        } else {

          this.checkPresetPromos();
          this.checkPresetChannels();
        }

        this.message.remove(this.loadingId);
        this.loadingPlans = false;

      },
      (e) => {
        console.error('Error loading channels', e);
        alert('Failed to load plan options.');
        this.message.remove(this.loadingId)
        this.loadingPlans = false;
      }
    );
  }

  private checkPresetPromos() {
    const fa = this.planForm.get('offers') as FormArray;
    this.promos.forEach((promo: any) =>
      promo.Product
        .filter((p: any) => p.PreselectFlag)
        .forEach((p: any) => fa.push(new FormControl(p.ProductId)))
    );
  }

  private checkPresetChannels() {
    const fa = this.planForm.get('addOnChannels') as FormArray;
    this.channels.forEach((ch: any) =>
      ch.offer
        .filter((o: any) => o.PreselectFlag)
        .forEach((o: any) => fa.push(new FormControl(o.ProductId)))
    );
  }

  getPlanOffers() {
    this.loadingPlans = true;
    this.message.remove(this.loadingId);
    this.loadingId = this.message.loading('Getting plan offers...', { nzDuration: 0 }).messageId;

    const selectedPlan = this.planForm.get('dishPlan')?.value;
    this.dishPlanOffers = selectedPlan?.RequiredProducts?.RequiredProduct?.[0]?.SelectSingleProduct?.Product ?? null;

    if (this.dishPlanOffers && this.dishPlanOffers.length) {
      this.message.remove(this.loadingId);
      this.loadingPlans = false;
    } else {
      this.message.remove(this.loadingId);
      this.loadingPlans = false;
      if (selectedPlan) {
        alert('Failed to get plan offers');
      }
    }
  }

  private groupPromos(promos: Array<{ CategoryName: string, Product: any[] }>): Array<{ CategoryName: string, Product: any[] }> {
    const map = new Map<string, { CategoryName: string, Product: any[] }>();
    for (const promo of promos) {
      if (map.has(promo.CategoryName)) {
        map.get(promo.CategoryName)!.Product.push(...promo.Product);
      } else {
        map.set(promo.CategoryName, {
          CategoryName: promo.CategoryName,
          Product: [...promo.Product],
        });
      }
    }
    return Array.from(map.values());
  }

  toggleProductId(formArrayName: 'addOnChannels' | 'offers', productId: number) {
    const array = this.planForm.get(formArrayName) as FormArray;
    const index = array.value.indexOf(productId);

    if (index > -1) {
      array.removeAt(index);
    } else {
      array.push(new FormControl(productId));
    }
  }

  isSelected(formArrayName: 'addOnChannels' | 'offers', productId: number): boolean {
    const array = this.planForm.get(formArrayName) as FormArray;
    return array.value.includes(productId);
  }

  toggleAddOnChannel(channelName: string, checked: boolean) {
    const control = this.planForm.get('addOnChannels');
    if (!control) return;

    let selected = control.value as string[];
    if (checked) {
      if (!selected.includes(channelName)) {
        selected.push(channelName);
      }
    } else {
      selected = selected.filter((ch) => ch !== channelName);
    }
    control.setValue(selected);
  }

  compareWithFn = (o1: any, o2: any) => o1?.ProductId === o2?.ProductId;

  submitPlan() {
    this.submittingLoader = true;
    this.message.remove(this.loadingId)
    this.loadingId = this.message.loading('Submitting selections...', { nzDuration: 0 }).messageId;
    const obj = this.planForm.value;
    const data = [
      ...this.planForm.get('addOnChannels')?.value,
      ...this.planForm.get('offers')?.value,
      this.planForm.get('dishPlan')?.value.ProductId,
      this.planForm.get('dishPlanOffer')?.value.ProductId
    ];

    this.data.postDataNoBodyDotBody({
      productIds: data,
      conversationId: this.fullData.conversationId,
      promoId: this.fullData.qual.promoId
    },'dish/validateProgramming').subscribe(
      (r: any) => {
        if (r.result === 'success') {
          this.data.postDataNoBodyDotBody({
            woId: this.fullData.woId,
            id: this.fullData.customerId,
            generic: {
              validateProgrammingResponse: r.data.ValidateProgrammingResponse,
              selectedChannels: data
            }
          },'work-order/update-generic').subscribe(
            (r: any) => {
              if (r.result === 'success') {
                this.message.remove(this.loadingId)
                this.plans.emit({ ...data, obj });
              } else {
                this.message.remove(this.loadingId)
                this.submittingLoader = false;
                alert('Failed to update work order.');
              }
            },
            (e) => {
              console.error('Error updating work order', e);
              alert('Failed to update work order.');
              this.message.remove(this.loadingId)
              this.submittingLoader = false;
            }
          );
        } else {
          alert(r.message.Status.PromptMessage);
          this.message.remove(this.loadingId)
          this.submittingLoader = false;
        }
      },
      (e) => {
        console.error('Error validating programming', e);
        alert('Failed to validate programming.');
        this.message.remove(this.loadingId)
        this.submittingLoader = false;
      }
    );
  }

  isAnyAddOnSelected(): boolean {
    return this.channels?.some((channel: any) =>
      channel?.offer?.some((offer: any) =>
        this.isSelected('addOnChannels', offer.ProductId)
      )
    );
  }

  isChannelActive(channel: any): boolean {
    return channel.offer?.some((offer: any) =>
      this.isSelected('addOnChannels', offer.ProductId)
    );
  }

  isAnyOfferSelected(): boolean {
    return this.promos?.some((promo: any) =>
      promo?.Product?.some((p: any) =>
        this.isSelected('offers', p.ProductId)
      )
    );
  }
  
  isPromoActive(promo: any): boolean {
    return promo?.Product?.some((p: any) =>
      this.isSelected('offers', p.ProductId)
    );
  }
}
